import Matrix4 from '../../../../foundation/algebra/linear/Matrix4';

export default class DrawInfo {

	public constructor (private vertexArray: number[], private colorArray: number[], private mode: number, private transformationMatrix: Matrix4) {}

	/*
	 * Query methods
	 */

	public getVertexArray () {
		return this.vertexArray;
	}

	public getColorArray () {
		return this.colorArray;
	}

	public getMode () {
		return this.mode;
	}

	public getTransformationMatrix () {
		return this.transformationMatrix;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/DrawInfo.ts